import React from 'react'
import { PropTypes } from 'prop-types'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

const Link = props => {
  const newStyles = {
    parent: props.parentStyles || {},
    ...props.styles
  }

  return (
    <a
      {...css(newStyles.link, newStyles.parent)}
      href={props.href}
      onClick={props.onClick}
      target={props.target}
      title={props.title}
    >
      {props.children}
    </a>
  )
}

Link.propTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func,
  target: PropTypes.string,
  title: PropTypes.string,
  styles: PropTypes.object.isRequired,
  parentStyles: PropTypes.object
}

export default withStyles(Styles)(Link)



// WEBPACK FOOTER //
// ./components/link/index.js